export default [
  {
    path: '/contact-requests',
    name: 'contactRequests',
    component: () => import('@/views/pages/contactRequest/ContactRequest.vue'),
  }
]